module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box direct-chat",
    class: [_vm.boxColor, _vm.directChatColor]
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.badgeColor,
    attrs: {
      "data-toggle": "tooltip",
      "title": "3 New Messages"
    }
  }, [_vm._v("3")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "direct-chat-messages"
  }, _vm._l((_vm.talkList), function(item) {
    return _c('va-direct-chat-item', {
      attrs: {
        "name": item.name,
        "date": item.date,
        "profileImage": item.profileImage,
        "message": item.message,
        "isMine": item.isMine
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-contacts"
  }, [_c('ul', {
    staticClass: "contacts-list"
  }, _vm._l((_vm.contacts), function(contact) {
    return _c('va-direct-chat-contact', {
      attrs: {
        "name": contact.name,
        "profileImage": contact.profileImage,
        "latestDate": contact.latestDate,
        "latestMessage": contact.latestMessage
      }
    })
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": _vm.placeholder
    }
  }), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Contacts",
      "data-widget": "chat-pane-toggle"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Send")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56cd5dac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VADirectChat.vue
// module id = 514
// module chunks = 1